import {Injectable} from "@angular/core";
import Swal from "sweetalert2"

@Injectable({providedIn: "root"})
export class ModalService {

  constructor() {
  }


  simpleConfirmation(body: { message: string, title?: string }): Promise<boolean> {
    return Swal.fire({
      text: body.message,
      title: body.title,
      confirmButtonText: 'Sim',
      showCancelButton: true,
      cancelButtonText: 'Não'
    }).then(result => result.isConfirmed === true)
  }

}
